import React, { useRef } from "react";
import { useHistory } from "react-router-dom";
import "../dashboard/css/Articles.css";

import article1 from "../dashboard/assets/Articles1.png";
import article2 from "../dashboard/assets/Articles2.png";
import article3 from "../dashboard/assets/Articles3.png";
import article4 from "../dashboard/assets/Articles4.webp";
import article5 from "../dashboard/assets/article5.webp";
import article6 from "../dashboard/assets/article6.jpeg";
import article7 from "../dashboard/assets/article7.webp";

const articles = [
  // ✅ Vadodara Articles
  {
    img: article1,
    title: "How to Choose the Right Tutor in Vadodara",
    desc:
      "Finding the right tutor in Vadodara can significantly impact a student’s academic success...",
    date: "01 January 2026",
    link: "/article1",
  },
  {
    img: article2,
    title:
      "Top Home Tutors in Vadodara: Area-Wise Guide for School Students",
    desc:
      "Vadodara has a growing demand for quality home tutors across various residential areas...",
    date: "02 January 2026",
      link: "/article2",
  },
  {
    img: article3,
    title:
      "5 Tips for Parents to Find the Best Home Tutors in Vadodara",
    desc:
      "Choosing the right home tutor for your child in Vadodara requires careful planning...",
    date: "03 January 2026",
          link: "/article3",
  },


  {
    img: article4,
    title: "Board Exam Success Stories from Ahmedabad Students",
    desc:
      "Discover how personalized home tuition in Ahmedabad helped students succeed in board exams...",
    date: "04 January 2026",
          link: "/article4",
  },
  {
    img: article5,
    title: "Why Home Tuition Is Better Than Coaching Classes in Ahmedabad",
    desc:
      "Ahmedabad students benefit greatly from personalized home tuition over crowded coaching classes...",
    date: "05 January 2026",
       link: "/article5",
  },
  {
    img: article6,
    title: "How Online Learning Is Transforming Education in Ahmedabad",
    desc:
      "Digital learning platforms are rapidly changing the education landscape in Ahmedabad...",
    date: "06 January 2026",
    link: "/article6",
  },
  {
    img: article7,
    title: "Best Study Habits Every Student in Ahmedabad Should Follow",
    desc:
      "Developing strong study habits helps Ahmedabad students stay focused and perform better...",
    date: "07 January 2026",
    link: "/article7",
  },
];

const Articles = () => {
  const listRef = useRef(null);
  const history = useHistory();

  const scroll = (dir) => {
    const card = listRef.current.children[0];
    const gap = 32;
    const scrollAmount = card.offsetWidth + gap;

    listRef.current.scrollBy({
      left: dir === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <section className="articles-section">
      <h2 className="articles-title">
        Recent <span>Articles</span>
      </h2>

      <div className="articles-wrapper">
        <button className="arrow left" onClick={() => scroll("left")}>
          ‹
        </button>

        <div className="articles-viewport">
          <div className="articles-list" ref={listRef}>
            {articles.map((item, i) => (
              <article
                className="article-card"
                key={i}
                onClick={() => item.link && history.push(item.link)}
                style={{ cursor: item.link ? "pointer" : "default" }}
              >
                <div className="article-img">
                  <img src={item.img} alt={item.title} />
                </div>
                <div className="article-content">
                  <span className="date">📅 {item.date}</span>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>

        <button className="arrow right" onClick={() => scroll("right")}>
          ›
        </button>
      </div>
    </section>
  );
};

export default Articles;